import React, { useState, useRef, useEffect } from "react";
import SignatureCanvas from "react-signature-canvas";
import { PDFDocument, rgb, StandardFonts } from "pdf-lib";
import { styled } from "@mui/system";
import Spinner from "./SpinnerPage";
import TextField from "@mui/material/TextField";
import Grid from "@mui/material/Unstable_Grid2";
import Stack from "@mui/material/Stack";
import Button from "@mui/material/Button";
import Alert from "@mui/material/Alert";

const Select = styled("select")({
  fontSize: "1rem",
  color: "#fff",
  backgroundColor: "#2D2D2D",
  "&:placeholder": {
    color: "#fff",
  },
  boxShadow: "inset 0 0.0625em 0.125em rgb(10 10 10 / 5%)",
  border: "1px solid transparent",
  borderRadius: "4px",
  maxWidth: "100%",
  width: "100%",
  height: "3.5rem",
  paddingBottom: "calc(0.5em - 1px)",
  paddingLeft: "calc(0.75em - 1px)",
  paddingRight: "calc(0.75em - 1px)",
  paddingTop: "calc(0.5em - 1px)",
});

export default function FormRegistro() {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState({
    name: "",
    dni: "",
    username: "",
    email: "",
    password: "",
    tel: "",
    phone: "",
    pais: "Argentina",
    ciudad: "Caracas",
    direccion: "",
    products: {
      id: 1,
    },
    id_corredor: 0,
  });
  const [firma64, setFirma64] = useState("");
  const [contrato64, setContrato64] = useState("");
  const [contrato642, setContrato642] = useState("");

  const [dataFiles, setDataFiles] = useState({
    firma: "",
    contrato: "",
  });

  const [successAlertShow, setSuccessAlertShow] = useState(false);
  const [errorAlertShow, setErrorAlertShow] = useState(false);
  const [message, setMessage] = useState("");

  const now = new Date();
  let year = now.getFullYear();
  let month = now.getMonth() + 1;
  let day = now.getDate();
  // let hour = now.getHours();
  // let minute = now.getMinutes();

  month = month.toString().padStart(2, "0");
  day = day.toString().padStart(2, "0");
  // hour = hour.toString().padStart(2, "0");
  // minute = minute.toString().padStart(2, "0");

  // const minDate = `${year}-${month}-${day}T${hour}:${minute}`;

  const sigCanvas = useRef({});

  useEffect(() => {
    const username = data.email.split("@")[0];
    setData({ ...data, username: username });
  }, [data.email]);

  // useEffect(() => {
  //   loadPdf();
  //   loadPdf2();
  // }, [
  //   data.name,
  //   data.dni,
  //   data.email,
  //   data.password,
  //   data.tel,
  //   data.phone,
  //   data.pais,
  //   data.direccion,
  //   firma64,
  // ]);

  function setFirma() {
    const signature = sigCanvas.current.toDataURL("image/png");
    // console.log(signature);

    const base64Image = signature; // La cadena base64 de la imagen
    // Convertir la cadena Base64 a un Blob
    const byteCharacters = atob(base64Image.split(",")[1]);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: "image/png" });

    // Crear un objeto de archivo (File) a partir del Blob
    const file = new File([blob], `firma-${data.username}.png`, {
      type: "image/png",
    });

    // console.log(base64Image);
    setFirma64(base64Image);
    setDataFiles({ ...dataFiles, firma: file });
  }

  // const loadPdf = async () => {
  //   console.log("PDF Started");

  //   const existingPdfBytes = await fetch(
  //     `${process.env.PUBLIC_URL}/documentos/EXTINSION DE RESPONSABILIDAD PM.pdf`
  //   ).then((res) => res.arrayBuffer());
  //   const pdfDoc = await PDFDocument.load(existingPdfBytes);

  //   const page = pdfDoc.getPages()[0];
  //   const helveticaFont = await pdfDoc.embedFont(StandardFonts.Helvetica);

  //   // Convertir la imagen en un objeto Uint8Array
  //   const imageUrl = firma64;
  //   const response = await fetch(imageUrl);
  //   const imageData = await response.arrayBuffer();
  //   const imageUint8Array = new Uint8Array(imageData);

  //   // Incrustar la imagen en el PDF
  //   const image = await pdfDoc.embedPng(imageUint8Array);
  //   const { width, height } = image.scale(1);

  //   // Dibujar la imagen en la página
  //   page.drawImage(image, {
  //     x: 320,
  //     y: 225,
  //     width: width / 2,
  //     height: height / 2,
  //   });

  //   page.drawText(data.name, {
  //     x: 172,
  //     y: 616,
  //     size: 12,
  //     font: helveticaFont,
  //     color: rgb(0, 0, 0),
  //   });

  //   page.drawText(data.name, {
  //     x: 320,
  //     y: 205,
  //     size: 12,
  //     font: helveticaFont,
  //     color: rgb(0, 0, 0),
  //   });

  //   page.drawText(data.dni, {
  //     x: 360,
  //     y: 187,
  //     size: 12,
  //     font: helveticaFont,
  //     color: rgb(0, 0, 0),
  //   });

  //   page.drawText(day, {
  //     x: 243,
  //     y: 298,
  //     size: 12,
  //     font: helveticaFont,
  //     color: rgb(0, 0, 0),
  //   });

  //   page.drawText(month, {
  //     x: 330,
  //     y: 298,
  //     size: 12,
  //     font: helveticaFont,
  //     color: rgb(0, 0, 0),
  //   });

  //   page.drawText(year.toString(), {
  //     x: 370,
  //     y: 298,
  //     size: 12,
  //     font: helveticaFont,
  //     color: rgb(0, 0, 0),
  //   });

  //   // Guardar el documento PDF
  //   const pdfBytes = await pdfDoc.save();

  //   // Descargar el PDF en el navegador
  //   const blob = new Blob([pdfBytes], { type: "application/pdf" });

  //   // setDataFiles({ ...dataFiles, contrato: file });

  //   setContrato64(blob);
  // };

  // const loadPdf2 = async () => {
  //   console.log("PDF Started");
  //   const existingPdfBytes = await fetch(
  //     `${process.env.PUBLIC_URL}/documentos/CONTRATO- DECLARACION DE LAVADA DE ACTIVOS Y SARLAF.pdf`
  //   ).then((res) => res.arrayBuffer());
  //   const pdfDoc = await PDFDocument.load(existingPdfBytes);

  //   const page = pdfDoc.getPages()[0];
  //   const page2 = pdfDoc.getPages()[2];
  //   const helveticaFont = await pdfDoc.embedFont(StandardFonts.Helvetica);

  //   // Convertir la imagen en un objeto Uint8Array
  //   const imageUrl = firma64;
  //   const response = await fetch(imageUrl);
  //   const imageData = await response.arrayBuffer();
  //   const imageUint8Array = new Uint8Array(imageData);

  //   // Incrustar la imagen en el PDF
  //   const image = await pdfDoc.embedPng(imageUint8Array);
  //   const { width, height } = image.scale(1);

  //   // Dibujar la imagen en la página
  //   page2.drawImage(image, {
  //     x: 100,
  //     y: 330,
  //     width: width / 3,
  //     height: height / 3,
  //   });

  //   page.drawText(data.name, {
  //     x: 92,
  //     y: 608,
  //     size: 12,
  //     font: helveticaFont,
  //     color: rgb(0, 0, 0),
  //   });

  //   page.drawText(data.dni, {
  //     x: 340,
  //     y: 608,
  //     size: 12,
  //     font: helveticaFont,
  //     color: rgb(0, 0, 0),
  //   });

  //   page2.drawText(data.name, {
  //     x: 165,
  //     y: 388,
  //     size: 12,
  //     font: helveticaFont,
  //     color: rgb(0, 0, 0),
  //   });

  //   page2.drawText(data.dni, {
  //     x: 132,
  //     y: 373,
  //     size: 12,
  //     font: helveticaFont,
  //     color: rgb(0, 0, 0),
  //   });

  //   page2.drawText(data.tel, {
  //     x: 92,
  //     y: 315,
  //     size: 12,
  //     font: helveticaFont,
  //     color: rgb(0, 0, 0),
  //   });

  //   page2.drawText(data.phone, {
  //     x: 112,
  //     y: 300,
  //     size: 12,
  //     font: helveticaFont,
  //     color: rgb(0, 0, 0),
  //   });

  //   page2.drawText(data.direccion, {
  //     x: 122,
  //     y: 285,
  //     size: 12,
  //     font: helveticaFont,
  //     color: rgb(0, 0, 0),
  //   });

  //   page2.drawText(data.email, {
  //     x: 110,
  //     y: 271,
  //     size: 12,
  //     font: helveticaFont,
  //     color: rgb(0, 0, 0),
  //   });

  //   page2.drawText(" ", {
  //     x: 110,
  //     y: 257,
  //     size: 12,
  //     font: helveticaFont,
  //     color: rgb(0, 0, 0),
  //   });

  //   page2.drawText(day, {
  //     x: 222,
  //     y: 431,
  //     size: 12,
  //     font: helveticaFont,
  //     color: rgb(0, 0, 0),
  //   });

  //   page2.drawText(month, {
  //     x: 302,
  //     y: 431,
  //     size: 12,
  //     font: helveticaFont,
  //     color: rgb(0, 0, 0),
  //   });

  //   page2.drawText(year.toString(), {
  //     x: 338,
  //     y: 431,
  //     size: 12,
  //     font: helveticaFont,
  //     color: rgb(0, 0, 0),
  //   });

  //   // Guardar el documento PDF
  //   const pdfBytes = await pdfDoc.save();

  //   // Descargar el PDF en el navegador
  //   const blob = new Blob([pdfBytes], { type: "application/pdf" });

  //   setContrato642(blob);
  // };

  const handleSubmit = async (e) => {
    // loadPdf();

    e.preventDefault();

    setLoading(true);

    const response = await fetch(
      `${process.env.REACT_APP_API_URL}/api/auth/local/register`,
      {
        method: "POST",
        headers: {
          Authorization: `Bearer ` + process.env.REACT_APP_API_TOKEN_EVENT,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      }
    );

    var dataRes = await response.json();
    // console.log(dataRes);

    if (response.status === 200) {
      setSuccessAlertShow(true);
      setErrorAlertShow(false);
      setMessage("Te has registrado exitosamente.");
      setLoading(false);

      setData({
        name: "",
        dni: "",
        username: "",
        email: "",
        password: "",
        tel: "",
        phone: "",
        pais: "Argentina",
        direccion: "",
        products: {
          id: 1,
        },
        id_corredor: 0,
      });

      sigCanvas.current.clear();

      // // Crear un objeto de archivo (File) a partir del Blob
      // const contrato_file = new File(
      //   [contrato64],
      //   `CONTRATO-${data.username}.pdf`,
      //   {
      //     type: "application/pdf",
      //   }
      // );

      // // Crear un objeto de archivo (File) a partir del Blob
      // const contrato_file_2 = new File(
      //   [contrato642],
      //   `SARLAF-${data.username}.pdf`,
      //   {
      //     type: "application/pdf",
      //   }
      // );

      // const formDataFiles = new FormData();

      // formDataFiles.append(
      //   "data",
      //   JSON.stringify({
      //     null: null,
      //   })
      // );

      // formDataFiles.append("files.firma", dataFiles.firma);
      // formDataFiles.append(`files.contracts`, contrato_file);
      // formDataFiles.append(`files.contracts`, contrato_file_2);

      // const response_files = await fetch(
      //   "https://strapi.wefundstrade.com/api/files-users",
      //   {
      //     method: "POST",
      //     headers: {
      //       Authorization: `Bearer ` + process.env.REACT_APP_API_TOKEN_EVENT,
      //     },
      //     body: formDataFiles,
      //   }
      // );

      // const dataResFiles = await response_files.json();
      // // console.log(dataResFiles);

      // if (response_files.status === 200) {
      //   // console.log(dataResFiles.data.id);

      //   const dataFilesUser = {
      //     files_user: dataResFiles.data.id,
      //   };

      //   const response_files_user = await fetch(
      //     `https://strapi.wefundstrade.com/api/users/${dataRes.user.id}`,
      //     {
      //       method: "PUT",
      //       headers: {
      //         Authorization: `Bearer ` + process.env.REACT_APP_API_TOKEN_EVENT,
      //         "Content-Type": "application/json",
      //       },
      //       body: JSON.stringify(dataFilesUser),
      //     }
      //   );

      //   const dataResFilesUser = await response_files_user.json();
      //   // console.log(dataResFilesUser);

      //   // const url = URL.createObjectURL(contrato64);
      //   // window.open(url, "_blank");
      // } else {
      //   console.log(dataRes);
      // }

      // setLoading(false);

      // setData({
      //   name: "",
      //   dni: "",
      //   username: "",
      //   email: "",
      //   password: "",
      //   tel: "",
      //   phone: "",
      //   pais: "Argentina",
      //   direccion: "",
      //   products: {
      //     id: 1,
      //   },
      //   id_corredor: 0,
      // });

      // sigCanvas.current.clear();
    } else {
      setLoading(false);
      console.log(dataRes);
      setSuccessAlertShow(false);
      setErrorAlertShow(true);
      setMessage(dataRes.error.message);
    }
  };

  const handleClear = () => {
    sigCanvas.current.clear();
    setFirma64("");
  };

  return (
    <>
      <form onSubmit={handleSubmit}>
        <Grid container spacing={2}>
          <Grid md={6} xs={12}>
            <TextField
              fullWidth
              variant="outlined"
              label="Nombre completo"
              type="text"
              required
              autoComplete="nope"
              value={data.name}
              onChange={(e) => setData({ ...data, name: e.target.value })}
            />
          </Grid>
          <Grid md={6} xs={12}>
            <TextField
              fullWidth
              variant="outlined"
              label="DNI"
              type="text"
              required
              autoComplete="nope"
              value={data.dni}
              onChange={(e) => setData({ ...data, dni: e.target.value })}
            />
          </Grid>

          <Grid md={6} xs={12}>
            <TextField
              fullWidth
              variant="outlined"
              label="Email"
              type="email"
              required
              autoComplete="nope"
              value={data.email}
              onChange={(e) => setData({ ...data, email: e.target.value })}
            />
          </Grid>
          <Grid md={6} xs={12}>
            <TextField
              fullWidth
              variant="outlined"
              label="Contraseña"
              type="password"
              required
              autoComplete="nope"
              value={data.password}
              onChange={(e) => setData({ ...data, password: e.target.value })}
            />
          </Grid>

          <Grid md={6} xs={12}>
            <TextField
              fullWidth
              variant="outlined"
              label="Número telefonico"
              type="text"
              required
              autoComplete="nope"
              value={data.tel}
              onChange={(e) => setData({ ...data, tel: e.target.value })}
            />
          </Grid>
          <Grid md={6} xs={12}>
            <TextField
              fullWidth
              variant="outlined"
              label="Número Celular"
              type="text"
              required
              autoComplete="nope"
              value={data.phone}
              onChange={(e) => setData({ ...data, phone: e.target.value })}
            />
          </Grid>

          <Grid md={6} xs={12}>
            <Select
              required
              value={data.pais}
              onChange={(e) => setData({ ...data, pais: e.target.value })}
            >
              <option>Argentina</option>
              <option>Bolivia</option>
              <option>Chile</option>
              <option> Colombia</option>
              <option> Costa Rica</option>
              <option> Cuba</option>
              <option> República Dominicana</option>
              <option> Ecuador</option>
              <option> España</option>
              <option> Guatemala</option>
              <option> Honduras</option>
              <option> México</option>
              <option> Nicaragua</option>
              <option> Panamá</option>
              <option> Paraguay</option>
              <option> Perú</option>
              <option> Puerto Rico</option>
              <option> Uruguay</option>
              <option> Venezuela</option>
              <option> Estados Unidos</option>
              <option> Filipinas</option>
            </Select>
          </Grid>
          <Grid md={6} xs={12}>
            <TextField
              fullWidth
              variant="outlined"
              label="Dirección"
              type="text"
              required
              value={data.direccion}
              onChange={(e) => setData({ ...data, direccion: e.target.value })}
            />
          </Grid>

          <Grid md={6} xs={12}>
            <label className="has-text-white">Firma</label>
            <br />
            <SignatureCanvas
              ref={sigCanvas}
              canvasProps={{
                width: 250,
                height: 100,
                className: `sigCanvas`,
              }}
              onEnd={() => setFirma()}
            />
          </Grid>
          <Grid md={6} xs={12}>
            <Stack direction="row" spacing={2}>
              <Button onClick={handleClear}>Borrar firma</Button>
            </Stack>
          </Grid>
        </Grid>

        <Grid md={6} xs={12} className="field" sx={{ textAlign: "center" }}>
          {loading === false ? (
            <>
              <Stack direction="row" spacing={2}>
                {firma64 !== "" ? (
                  <Button type="submit" variant="contained" >
                    Registrarse
                  </Button>
                ) : null}

                {/* <Button
                  variant="outlined"
                  href={`${process.env.PUBLIC_URL}/documentos_legales/EXTINSION DE RESPONSABILIDAD PM.pdf`}
                  target={"_blank"}
                >
                  Ver contrato
                </Button> */}
              </Stack>
            </>
          ) : (
            <Spinner />
          )}
        </Grid>
      </form>

      {successAlertShow === true ? (
        <>
          <br />
          <Alert severity="success">{message}</Alert>
        </>
      ) : null}

      {errorAlertShow === true ? (
        <>
          <br />
          <Alert severity="error">{message}</Alert>
        </>
      ) : null}

      {/* <button onClick={loadPdf2}>Cargar PDF y agregar texto</button>
      <button onClick={loadPdf}>Cargar PDF y agregar texto</button> */}
    </>
  );
}
